// extracted by mini-css-extract-plugin
export var actionButton = "_5u-1";
export var actionButtons = "_5u-2";
export var actions = "_5u-0";
export var aiUnread = "_5u-10";
export var alignCenter = "_5u-h";
export var backWrapper = "_5u-3";
export var cellContainer = "_5u-4";
export var checkboxContainer = "_5u-5";
export var contentContainer = "_5u-6";
export var contentHeader = "_5u-8";
export var conversationsTableWrapper = "_5u-s";
export var draftReplyBadgeContainer = "_5u-m";
export var dropdownItem = "_5u-b";
export var dropdownItemsContainer = "_5u-a";
export var dropdownTitle = "_5u-c";
export var errorIcon = "_5u-7";
export var filter = "_5u-d";
export var gray = "_5u-i";
export var headerActionButtons = "_5u-e";
export var headerCheckboxContainer = "_5u-f";
export var icon = "_5u-j";
export var menuContainer = "_5u-k";
export var noMoreTicketsIcon = "_5u-12";
export var noMoreTicketsSubText = "_5u-13";
export var oneLine = "_5u-l";
export var optionsButton = "_5u-n";
export var plus = "_5u-o";
export var portalButtonsWrapper = "_5u-g";
export var red = "_5u-p";
export var scrolledTop = "_5u-9";
export var search = "_5u-q";
export var selectedConversationsCount = "_5u-r";
export var spinner = "_5u-t";
export var strong = "_5u-u";
export var summaryCell = "_5u-v";
export var tableContainer = "_5u-11";
export var tagContainer = "_5u-w";
export var threeDots = "_5u-x";
export var twoLines = "_5u-y";
export var unread = "_5u-z";